<script setup lang="ts">

import {Expandable} from '@hantera/design-system'
import {Component} from "./rule-types";
import RuleComponentParameter from "./RuleComponentParameter.vue";
import {computed} from "vue";

const props = defineProps<{
  ruleComponent: {
    componentId: string
    parameters: Record<string, string>
  }
  components: Component[]
}>();

const emit = defineEmits<{
  (e: 'remove'): void
}>()

const component = computed(() => {
  return props.components.find(r => r.componentId === props.ruleComponent.componentId);
})

</script>

<template>
  <div v-if="!component" class="box-content p">
    <div
      class="box-content-label"
    >
      Deleted promotion type

      <button class="btn-link" type="button" @click="emit('remove')">Remove</button>
    </div>
  </div>
  
  <div class="box-content p" v-else>
    
    <Expandable>
      
      <template v-slot:label>
        <div
          class="box-content-label"
        >
          {{component.displayName}}
  
          <button class="btn-link" type="button" @click="emit('remove')">Remove</button>
        </div>
      </template>
      
      <template v-slot:default>
        <RuleComponentParameter
          v-for="name in Object.keys(component.parameters)"
          :key="name"
          :parameter-name="name"
          :parameter-type="component.parameters[name]"
          :parameters="ruleComponent.parameters"
        />
      </template>
      
    </Expandable>
    
  </div>
  
</template>

<style scoped>

</style>